import React, { ReactElement, useEffect, useState } from 'react';
import styles from './style.module.scss';
import { testIds } from 'constants/test-constants';
import { buildClassName } from 'utils/build-class-name';
import { sanitizeTestid } from 'utils/stringSanitization';
import { useExperiment } from '@growthbook/growthbook-react';
import { useThemeContext } from 'contexts/theme';
import { ThemeNames } from 'types/themes';

interface Props {
  testId?: string;
  children: (ReactElement | null)[];
  className?: string;
}

export default function Tabs({ testId, children, className }: Props) {
  const tabs = children.filter(Boolean) as ReactElement[];
  const tabLabels = tabs.map(tab => tab.props.label);
  const [activeTab, setActiveTab] = useState(tabLabels.length ? tabLabels[0] : '');
  const abTestingSimilarListings = useExperiment({ key: 'similar-listings', variations: [0, 1], weights: [.1, .9]});
  const isAbSimilarExperimentOn = abTestingSimilarListings.variationId === 1;

  useEffect(() => {
    tabLabels.length > 0 && setActiveTab(tabLabels[0]);
  }, tabLabels);

  const handleTabClick = (label: string, gtmTrackEvent?: any) => {
    setActiveTab(label);
    typeof(gtmTrackEvent) === 'function' && gtmTrackEvent();
  };
  const { themeName } = useThemeContext();
  const expTabStyles = themeName !== ThemeNames.ZOOCASA ? styles.exptabs : '';

  return (
    <div className={buildClassName(isAbSimilarExperimentOn ? styles['component-experiment']: styles['component-no-experiment'], className, expTabStyles)} data-testid={testId}>
      <ul className={styles.tabs}>
        {tabs.map((tab, index) => {
          const { label, gtmTrackEvent } = tab.props;
          return (
            <li key={index} className={label === activeTab ? styles.active : ''} onClick={() => handleTabClick(label, gtmTrackEvent)} data-testid={sanitizeTestid(label)+ testIds.tabLink}>
              {label}
            </li>
          );
        })}
      </ul>
      {tabs.map(tab => (
        <div key={tab.props.label} style={{ display: tab.props.label === activeTab ? 'block' : 'none' }}>
          {tab}
        </div>
      ))}
    </div>
  );
}
